<template>
	<div class="mixtureBusinessModal_warp" ref="mixtureBusinessModal_ref">
		<a-modal
			v-model:visible="isShow"
			:title="title"
			:footer="null"
			:confirm-loading="confirmLoading"
			:getContainer="() => this.$refs.mixtureBusinessModal_ref"
		>
			<div class="mixtureBusinessModal_warp_header">
				<p class="mixtureBusinessModal_warp_header_hint">
					检测成功数{{ successLinks.length }}条，失败数{{ failLinks.length }}条
				</p>
			</div>

			<div class="mixtureBusinessModal_warp_successbox">
				<div class="title">检测成功：{{ successLinks.length }}</div>
				<div class="url" v-for="item in successLinks" v-bind:key="item">
					{{ item }}
				</div>
			</div>
			<div class="mixtureBusinessModal_warp_failbox">
				<div class="header">
					<div class="title">检测失败：{{ failLinks.length }}</div>
					<div class="copy"><a @click="copy">一键复制</a></div>
				</div>
				<div class="url" v-for="item in failLinks" v-bind:key="item">
					{{ item }}
				</div>
			</div>
			<div class="business-body">
				<div class="left_tk_title">
					<div class="left_tk_title_block"></div>
					<div class="left_tk_title_content">
						{{ this.$lang.GetLangByKey('TikTok') }}
					</div>
				</div>
				<div class="left_tk_content">
					<div
						@click="showConfig(item.id)"
						class="left_tk_content_item"
						:class="
							item.bgcolor === `red` ? `left_tk_content_item_red` : `left_tk_content_item_blue`
						"
						v-for="(item, index) in tkData"
						:key="index"
					>
						<div class="left_tk_content_item_row1">
							<div class="left_tk_content_item_row1_icon">
								<Icon :icon="item.icon"></Icon>
							</div>
							<div class="left_tk_content_item_row1_price">
								{{ is_hidden_price == 1 ? '**' : item.price }}
							</div>
						</div>
						<div class="left_tk_content_item_row2">
							{{ item.title }}
						</div>
					</div>
				</div>
			</div>
			<div>
				<batch-order-confirm-modal
					v-model:visible="batchOrderConfirmData.isShow"
					@changeVisible="batchOrderConfirmChangeVisible"
					:on-submit="batchOrderConfirmSubmit"
					:price="batchOrderConfirmData.price"
					:code="batchOrderConfirmData.code"
					:check-info="batchOrderConfirmData.checkInfo"
					:linksProp="batchOrderConfirmData.linksProp"
					:successLinksProp="batchOrderConfirmData.successLinksProp"
					:failLinksProp="batchOrderConfirmData.failLinksProp"
					:title="batchOrderConfirmData.title"
				/>
				<batch-comments-order-confirm-modal
					v-model:visible="batchCommentsOrderConfirmData.isShow"
					@changeVisible="batchOrderCommentsConfirmChangeVisible"
					:on-submit="batchOrderConfirmSubmit"
					:price="batchOrderConfirmData.price"
					:code="batchOrderConfirmData.code"
					:check-info="batchOrderConfirmData.checkInfo"
					:linksProp="batchOrderConfirmData.linksProp"
					:successLinksProp="batchOrderConfirmData.successLinksProp"
					:failLinksProp="batchOrderConfirmData.failLinksProp"
					:title="batchOrderConfirmData.title"
				></batch-comments-order-confirm-modal>
				<order-success-modal
					v-model:visible="orderSuccessVisible"
					@changeVisible="orderSuccesschangeVisible"
				></order-success-modal>
			</div>
		</a-modal>
	</div>
</template>
<script>
	import cookies from 'js-cookie';
	import orderApi from '@/http/apiUtil/orderApi';
	import userApi from '@/http/apiUtil/userApi';
	import { ref, h } from 'vue';
	import { Icon } from '@/components/util/iconUtil.js';
	import batchOrderConfirmModal from '@/components/transactions/batchOrderConfirmModal.vue';
	import batchCommentsOrderConfirmModal from '@/components/transactions/batchCommentsOrderConfirmModal.vue';
	import orderSuccessModal from '@/components/order/orderSuccessModal.vue';
	export default {
		components: {
			Icon,
			batchOrderConfirmModal,
			batchCommentsOrderConfirmModal,
			orderSuccessModal,
		},
		props: {
			title: { type: String, default: '' },
			visible: { type: Boolean, default: false },
			price: { type: Number, default: null },
			code: { type: String, default: null },
			successLinksProp: { type: Array, default: ref([]) },
			failLinksProp: { type: Array, default: ref([]) },
			onSubmit: { type: Function, default: null },
			checkInfo: { type: Array, default: ref([]) },
		},
		data() {
			const radioValue = '1';
			return {
				is_hidden_price: cookies.get('is_hidden_price'),
				radioValue: radioValue,
				isShow: false,
				orderSuccessVisible: false,
				confirmLoading: false,
				isFull: false,
				compact: false,
				config_step: 100,
				config_info: null,
				successLinks: [],
				failLinks: [],
				tkData: [],
				isCheckTiered: false,
				tiered_total_amount: 0,
				tiered_detail: [],
				batchOrderConfirmData: {
					isShow: false,
					price: 0,
					code: null,
					linksProp: null,
					checkInfo: [],
					successLinksProp: [],
					failLinksProp: [],
					title: '',
				},
				batchCommentsOrderConfirmData: {
					isShow: false,
				},
			};
		},
		mounted() {},
		methods: {
			copy() {
				if (!this.failLinksProp || this.failLinksProp.length === 0) {
					this.$message.error('没有数据可以复制');
					return;
				}
				let text = this.failLinksProp.join('\n');
				// 创建输入框元素
				let oInput = document.createElement('textarea');
				// 将想要复制的值
				oInput.value = text;
				// 页面底部追加输入框
				document.body.appendChild(oInput);
				// 选中输入框
				oInput.select();
				// 执行浏览器复制命令
				document.execCommand('Copy');
				// 弹出复制成功信息
				this.$message.success('复制成功');
				// 复制后移除输入框
				oInput.remove();
			},
			async getBussiness() {
				var res = await userApi.ConfigInfo({ business_type: 4 });
				console.log(res);
				if (res.ret_code == 200) {
					res.ret_obj.forEach((item, index) => {
						console.log(index);
						let info = {
							config_unit: item.config_unit,
							id: item.config_code,
							title: item.config_name,
						};
						info.price = item.config_price;
						//对用户展示的部分数据做单个价格显示
						if (!(info.id == 1003 || info.id == 1007 || info.id == 21007)) {
							info.price /= item.config_unit;
						}
						info.price = this.$util.format1000Price(info.price);
						if (
							!(
								info.id == 1002 ||
								info.id == 1001 ||
								info.id == 1003 ||
								info.id == 1007 ||
								info.id == 21007
							)
						) {
							if (info.id == 1004 || info.id == 21004) {
								info.price += '/条';
							} else {
								info.price += '/个';
							}
						}
						info.singlePrice = item.config_price;
						info.price += this.$lang.GetLangByKey('PriceUnit');
						switch (item.config_code) {
							case 1001:
								info.icon = 'FireOutlined';
								break;
							case 1002:
								info.icon = 'MessageOutlined';
								break;
							case 1003:
								info.icon = 'LikeOutlined';
								break;
							case 21004:
							case 1004:
								info.icon = 'MessageOutlined';
								break;
							case 1005:
							case 21005:
								info.icon = 'LikeOutlined';
								break;
							case 1006:
							case 21006:
							case 41006:
								info.icon = 'UserAddOutlined';
								break;
							case 1007:
							case 21007:
								info.icon = 'VideoCameraOutlined';
								break;
							case 1008:
							case 21008:
								info.icon = 'ShareAltOutlined';
								break;
							case 1009:
							case 21009:
								info.icon = 'StarOutlined';
								break;
						}
						if (info.title.indexOf('批量') > -1) {
							info.bgcolor = 'red';
						} else {
							info.bgcolor = 'blue';
						}
						this.tkData.push(info);
					});
					console.log(this.tkData);
				}
			},
			async showConfig(id) {
				let info = this.tkData.find((t) => t.id == id);
				this.batchOrderConfirmData.title = info.title;
				//this.batchOrderConfirmData.linksProp = param.order_links;
				this.batchOrderConfirmData.successLinksProp = this.successLinksProp;
				this.batchOrderConfirmData.failLinksProp = this.failLinksProp;
				this.batchOrderConfirmData.code = id;
				this.batchOrderConfirmData.price = info.singlePrice;
				this.batchOrderConfirmData.checkInfo = this.checkInfo;
				if (id != '21004') {
					this.batchOrderConfirmChangeVisible(true);
				} else {
					this.batchOrderCommentsConfirmChangeVisible(true);
				}
			},
			batchOrderConfirmChangeVisible(flag) {
				this.batchOrderConfirmData.isShow = flag;
			},
			batchOrderCommentsConfirmChangeVisible(flag) {
				this.batchCommentsOrderConfirmData.isShow = flag;
			},
			orderSuccesschangeVisible(flag) {
				this.orderSuccessVisible = flag;
			},
			async batchOrderConfirmSubmit(args) {
				console.log(args);
				console.log(h);
				// if (args.order_robot_count == null || args.order_robot_count == 0) {
				// 	this.$message.error('请输入订单数量');
				// 	return;
				// }
				console.log(args);
				let res = await orderApi.batchLiveOrderPlace(args);

				if (res.ret_code == 200) {
					//this.$message.success("下单成功");
					// 下单成功弹窗
					this.orderSuccesschangeVisible(true);
					this.batchOrderConfirmChangeVisible(false);
					this.batchOrderCommentsConfirmChangeVisible(false);
				} else {
					this.$message.destroy();
					var msgList = res.ret_msg.split('<br/>');
					var pList = [];
					msgList.forEach((item) => {
						pList.push(h('div', item));
					});
					if (res.ret_obj && res.ret_obj.length > 0) {
						this.$modal.confirm({
							getContainer: () => this.$refs.mixtureBusinessModal_ref,
							onOk: async () => {
								let text = res.ret_obj.join('\n');
								// 创建输入框元素
								let oInput = document.createElement('textarea');
								// 将想要复制的值
								oInput.value = text;
								// 页面底部追加输入框
								document.body.appendChild(oInput);
								// 选中输入框
								oInput.select();
								// 执行浏览器复制命令
								document.execCommand('Copy');
								// 弹出复制成功信息
								this.$message.success('复制成功');
								// 复制后移除输入框
								oInput.remove();
								return Promise.reject();
							},
							okText: '复制失败TK号或链接',
							cancelText: '知道了',
							title: h(
								'div',
								{
									style: {
										color: '#0086f5',
										'font-size': '18px',
										'font-weight': '600',
									},
								},
								'提示'
							),
							content: h(
								'div',
								{
									style: {
										color: '#0086f5',
										'font-size': '14px',
										'font-weight': '600',
									},
								},
								pList
							),
						});
					} else {
						this.$modal.error({
							getContainer: () => this.$refs.mixtureBusinessModal_ref,
							onOk: () => {},
							title: h(
								'div',
								{
									style: {
										color: '#0086f5',
										'font-size': '18px',
										'font-weight': '600',
									},
								},
								'提示'
							),
							content: h(
								'div',
								{
									style: {
										color: '#0086f5',
										'font-size': '14px',
										'font-weight': '600',
									},
								},
								pList
							),
						});
					}
				}
				// this.getUserAmount();
				// this.getOrderList();
			},
		},
		setup() {},
		watch: {
			visible: {
				immediate: true,
				handler(a) {
					this.isShow = a;
				},
			},
			isShow: {
				handler(a) {
					this.$emit('changeVisible', a);
				},
			},
			successLinksProp: {
				handler(value) {
					this.successLinks = value;
				},
			},
			failLinksProp: {
				handler(value) {
					this.failLinks = value;
				},
			},
			code: {
				async handler(value) {
					console.log(value);
					if (!value) {
						return;
					}
					this.getBussiness();
				},
			},
		},
	};
</script>
<style lang="scss" scoped>
	.buttonGroup {
		padding-top: 25px;
		text-align: center;
	}

	.mixtureBusinessModal_warp {
		.mixtureBusinessModal_warp-body {
			width: 70%;
			margin: 0px auto;
		}

		:deep(.ant-input-number-handler) {
			border-left: none;
		}

		:deep(.ant-input-number-handler-up) {
			background-image: url(/src/assets/icon/icon-add.png);
			background-size: cover;
			background-color: white;
			width: 48%;
			height: 100% !important;
		}

		:deep(.ant-input-number-handler-down) {
			background-image: url(/src/assets/icon/icon-minus.png);
			background-size: cover;
			background-color: white;
			width: 48%;
			margin-left: 2%;
			height: 100% !important;
			border-top: none;
		}

		:deep(.ant-input-number-handler-wrap) {
			display: flex;
			position: absolute;
			right: -4.6rem;
			width: 4.4rem !important;
			height: 1.4rem;
			top: 0.2rem;
		}

		.range-container {
			display: flex;
			align-items: center;
			justify-content: center;
			:deep(.ant-input-number-handler-wrap) {
				display: none;
			}
		}

		:deep(.anticon-up > svg) {
			display: none;
		}

		:deep(.anticon-down > svg) {
			display: none;
		}

		::v-deep {
			.ant-modal-content {
				//   min-width: 449px;
				//   min-height: 597px;
				background: #e5f3ff;
				box-shadow: 4px 13px 20px 0px rgba(146, 146, 146, 0.49);
				border-radius: 12px;
			}

			.mixtureBusinessModal_warp_header {
				padding-left: 10%;
				padding-right: 10%;

				.mixtureBusinessModal_warp_header_hint {
					font-size: 12px;
					font-family: PingFangSC-Semibold, PingFang SC;
					text-align: left;
					background: #cde8ff;
					box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07),
						inset 0px 1px 4px 0px rgba(0, 80, 157, 0.77);
					border-radius: 8px;
					border: 1px solid #0075f3;
					text-align: center;
					line-height: 38px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #0086f5;
				}
			}

			.mixtureBusinessModal_warp_databody {
				.mixtureBusinessModal_warp_databody_tips {
					padding-top: 0px;
					padding-left: 50%;
					font-size: 12px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #0091ff;

					.exceed {
						color: red;
					}
				}
			}

			.ant-input-group.ant-input-group-compact {
				.ant-select:last-child {
					.ant-select-selector {
						border-radius: 15px;
					}
				}
			}

			.ant-modal-header {
				background: #e5f3ff;
				border-radius: 12px;
				text-align: center;
				border-bottom: 0px;
			}

			.ant-modal-title {
				font-size: 14px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #0086f5;
				line-height: 20px;
			}
		}

		.mixtureBusinessModal_warp_successbox {
			width: 322px;
			height: 100px;
			background: #ffffff;
			border-radius: 15px;
			opacity: 0.8;
			margin: 0px auto;
			overflow-y: auto;

			.title {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #0091ff;
				line-height: 30px;
				padding-left: 1rem;
			}

			.url {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #0091ff;
				line-height: 20px;
				padding-left: 1rem;
			}
		}

		.mixtureBusinessModal_warp_failbox {
			width: 322px;
			height: 100px;
			background: #ebfffa;
			border-radius: 15px;
			opacity: 0.8;
			margin: 1rem auto 0px;
			overflow-y: auto;

			.header {
				display: flex;
				position: relative;

				.title {
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #44d7b6;
					line-height: 30px;
					padding-left: 1rem;
				}

				.copy {
					line-height: 30px;
					position: absolute;
					right: 1rem;
				}
			}

			.url {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #44d7b6;
				line-height: 20px;
				padding-left: 1rem;
			}
		}
		.business-body {
			.left_tk_title {
				display: flex;

				.left_tk_title_block {
					width: 4px;
					height: 22px;
					background: linear-gradient(180deg, #00bbfb 0%, #0086f5 100%);
					border-radius: 4px;
				}

				.left_tk_title_content {
					margin-left: 8px;
					font-size: 16px;
					font-weight: 500;
					color: #0086f5;
				}
			}
			.left_tk_content {
				display: grid;
				// justify-content: space-around;
				justify-content: space-evenly;
				grid-template-columns: repeat(auto-fill, 170px);
				grid-gap: 30px;
				margin-top: 20px;
				padding-bottom: 20px;

				.left_tk_content_item_blue {
					background: linear-gradient(39deg, #00a4fa 0%, #006bf2 100%);
					border-radius: 22px;
					border: 1px solid #26a6ee;
				}

				.left_tk_content_item_red {
					background: linear-gradient(150deg, #fa7d74 0%, #f94e39 100%);
					border-radius: 22px;
					border: 1px solid #ff8778;
				}

				.left_tk_content_item {
					cursor: pointer;
					height: 110px;
					width: 190px;
					padding: 12px;

					.left_tk_content_item_row1 {
						display: flex;
						justify-content: space-between;
						align-items: flex-end;

						.left_tk_content_item_row1_icon {
							font-size: 30px;
							color: white;
						}

						.left_tk_content_item_row1_price {
							font-size: 25px;
							color: white;
						}
					}

					.left_tk_content_item_row2 {
						margin-top: 9px;
						font-size: 13px;
						font-weight: bold;
						color: #ffffff;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 720px) {
		.mixtureBusinessModal_warp {
			.mixtureBusinessModal_warp-body {
				width: 90%;
				margin: 0px auto;
			}
		}
	}
</style>
